export const TextOnlyHeroTheme = {
  light: {
    background: 'bg-warm-neutral-100',
    heading: 'text-primary',
    text: 'text-on-primary-surface',
    buttonStyle: 'default' as const
  },
  none: {
    background: '',
    heading: 'text-primary',
    text: 'text-on-primary-surface',
    buttonStyle: 'default' as const
  },
  piggybank: {
    background: (invertColors: boolean) =>
      invertColors ? 'bg-accent5-weakest' : 'bg-accent5-strongest',
    heading: (invertColors: boolean) =>
      invertColors ? 'text-accent5-strongest' : 'text-piggybank-400',
    text: (invertColors: boolean) =>
      invertColors ? 'text-on-screen-surface' : 'text-on-screen-surface-dark',
    buttonStyle: (invertColors: boolean) =>
      invertColors ? ('default' as const) : ('dark' as const)
  },
  lagoon: {
    background: (invertColors: boolean) =>
      invertColors ? 'bg-accent2-weakest' : 'bg-accent2-strongest',
    heading: (invertColors: boolean) =>
      invertColors ? 'text-accent2-strongest' : 'text-accent2-base',
    text: (invertColors: boolean) =>
      invertColors ? 'text-on-screen-surface' : 'text-on-screen-surface-dark',
    buttonStyle: (invertColors: boolean) =>
      invertColors ? ('default' as const) : ('dark' as const)
  },
  grape: {
    background: (invertColors: boolean) =>
      invertColors ? 'bg-accent1-weakest' : 'bg-accent1-strongest',
    heading: (invertColors: boolean) =>
      invertColors ? 'text-accent1-strongest' : 'text-accent1-base',
    text: (invertColors: boolean) =>
      invertColors ? 'text-on-screen-surface' : 'text-on-screen-surface-dark',
    buttonStyle: (invertColors: boolean) =>
      invertColors ? ('default' as const) : ('dark' as const)
  },
  tangerine: {
    background: (invertColors: boolean) =>
      invertColors ? 'bg-accent4-weakest' : 'bg-accent4-strongest',
    heading: (invertColors: boolean) =>
      invertColors ? 'text-accent4-strongest' : 'text-accent4-base',
    text: (invertColors: boolean) =>
      invertColors ? 'text-on-screen-surface' : 'text-on-screen-surface-dark',
    buttonStyle: (invertColors: boolean) =>
      invertColors ? ('default' as const) : ('dark' as const)
  },
  lime: {
    background: (invertColors: boolean) =>
      invertColors ? 'bg-accent3-weakest' : 'bg-accent3-strongest',
    heading: (invertColors: boolean) =>
      invertColors ? 'text-accent3-strongest' : 'text-accent3-base',
    text: (invertColors: boolean) =>
      invertColors ? 'text-on-screen-surface' : 'text-on-screen-surface-dark',
    buttonStyle: (invertColors: boolean) =>
      invertColors ? ('default' as const) : ('dark' as const)
  },
  brand: {
    background: (invertColors: boolean) =>
      invertColors ? 'bg-brand-weakest' : 'bg-brand-strongest',
    heading: (invertColors: boolean) =>
      invertColors ? 'text-brand-strongest' : 'text-brand-base',
    text: (invertColors: boolean) =>
      invertColors ? 'text-on-screen-surface' : 'text-on-screen-surface-dark',
    buttonStyle: (invertColors: boolean) =>
      invertColors ? ('default' as const) : ('dark' as const)
  }
} as const;

export type HeroColorTheme = keyof typeof TextOnlyHeroTheme;

export interface HeroThemeClasses {
  background: string;
  heading: string;
  text: string;
  buttonStyle: 'default' | 'dark';
  isStrongest: boolean;
}

export const getHeroThemeClasses = (
  colorTheme: string,
  invertColors: boolean
): HeroThemeClasses => {
  const themeKey = Object.prototype.hasOwnProperty.call(
    TextOnlyHeroTheme,
    colorTheme as PropertyKey
  )
    ? (colorTheme as HeroColorTheme)
    : 'light';

  const theme = TextOnlyHeroTheme[themeKey];
  const isStrongest =
    themeKey !== 'light' && themeKey !== 'none' && !invertColors;

  return {
    background:
      typeof theme.background === 'function'
        ? theme.background(invertColors)
        : theme.background,
    heading:
      typeof theme.heading === 'function'
        ? theme.heading(invertColors)
        : theme.heading,
    text:
      typeof theme.text === 'function' ? theme.text(invertColors) : theme.text,
    buttonStyle:
      typeof theme.buttonStyle === 'function'
        ? theme.buttonStyle(invertColors)
        : theme.buttonStyle,
    isStrongest
  };
};
